import type { Gutter } from "antd/lib/grid/row";

export const rowGutter: any = [24, 16];
export const rowTitleGutter: any = 32;

export const xs: any = { span: 24 };
export const xxl: any = { span: 9 };

export const addressXS: any = { span: 24 };
export const addressMD: any = { span: 8 };
export const addressLG: any = { span: 8 };
export const addressXXL: any = { span: 8 };

export const cellMD: any = { span: 9 };
export const cellLG: any = { span: 9 };

export const gridItem = {
  xs: { span: 24 },
  sm: { span: 12 }
};

export const gridContainer = {
  gutter: [24, 16] as [Gutter, Gutter],
  justify: "start" as const,
  align: "top" as const
};
